import React, { Component } from "react";
import {
    Column,    
    FilterRow,
    Lookup,
    Pager,
    Paging,
    Export,
    Editing,
    Popup,
    Form,
    RequiredRule,
    StringLengthRule,
    EmailRule,
    ColumnChooser
}
    from 'devextreme-react/data-grid';
    
import { DataGrid } from 'devextreme-react';
import { confirm } from 'devextreme/ui/dialog';
import { createStore } from "../../utils/proxy";
import BlockHeader from '../../components/shared/BlockHeader';
import Title from "../../components/shared/Title";
import { store } from "../../services/store";
import { formatNumberPhone } from "../../utils/common";
import { Item } from "devextreme-react/form";
import uri from "../../utils/uri";
import http from "../../utils/http";
import notify from "devextreme/ui/notify";
import { editorOptionsSwitch, editorOptsDateBox, editorOptsTextBox } from "../../data/app";

class Users extends Component {

    constructor(props) {
        super(props)

        this.store = null
        this.dataGrid = null;
        this.reload = this.reload.bind(this);
        this.addMenuItems = this.addMenuItems.bind(this);

    }

    reload() {
        this.dataGrid.instance.refresh();
    }

    addMenuItems (e) {

        if (e.target == "content") {
            if (!e.items) e.items = [];

            let { username, active } = e.row.data;
 
            e.items.push({
                text: `Editar usuario`,
                icon : 'user',
                onItemClick: () => { 

                    this.dataGrid.instance.editRow(e.rowIndex);

                }
            },{
                text: `${active ? 'Anular' : 'Activar'} usuario`,
                icon :  active ? 'remove' : 'check',
                color : 'red',
                onItemClick: () => {    
                    
                    let result = confirm(`<i>Estas seguro de ${active?'anular':'activar'} este usuario?</i>
                        ${active ? '<p class="text-danger">El usuario ya no podra hacer uso del sistema</p>' : ''}`, "Confirmar");

                    result.then((dialogResult) => {
                        if(dialogResult)
                            http('users/update').asGet({username, active: !active}).then(resp => {
                                this.reload();
                                notify("Usuario actualizado correctamente");
                            });    
                    });                                   

                }
            },{
                text: `Restablecer contraseña`,
                icon :  'refresh',
                onItemClick: () => {
                    
                    let result = confirm("<i>Estas seguro de restablecer la contraseña?</i>", "Confirmar");
                    result.then((dialogResult) => {
                        if(dialogResult)
                            http('account/resetpassworddefault').asPost({username}).then(resp => {
                                notify("Contraseña retablecida correctamente");
                                this.reload();
                            });
                    });

                   
                }
            });
        }
    }

    onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon: 'xlsxfile',
                type: 'success',
                stylingMode: "outlined",
                onClick: () => this.dataGrid.instance.exportToExcel(false)
            }
        },{
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Agregar nuevo usuario',
                icon: 'add',
                type: 'default',
                stylingMode: "outlined",
                onClick: () => this.dataGrid.instance.addRow()
            }
        });
    }

    render() {
        let remoteOperations = true;
        this.store = store(
            {
                uri: uri.usersManagement,
                msgInserted: 'Usuario agregado correctamente',
                msgUpdated: 'Usuario modificado correctamente',
                msgDeleted: 'Usuario eliminado correctamente',
                remoteOperations: remoteOperations
            });
        const title = "Usuarios";
        return (
            <div className="container">
                <Title title={title} />
                <BlockHeader title={title} />
                <DataGrid
                    ref={(ref) => this.dataGrid = ref}
                    dataSource={this.store}
                    selection={{ mode: 'single' }}
                    showBorders={true}
                    showRowLines={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    hoverStateEnabled={true}
                    rowAlternationEnabled={true}
                    remoteOperations={{
                        paging: true,
                        filtering: true
                    }}
                    onContextMenuPreparing={this.addMenuItems}
                    onToolbarPreparing={this.onToolbarPreparing}
                >
                    <ColumnChooser enabled={true} />
                    <Pager allowedPageSizes={[10, 15, 30, 50]} showPageSizeSelector={true} showInfo={true} />
                    <Paging defaultPageSize={15} />
                    <FilterRow visible={true} />
                    <Export enabled={true} fileName={title} allowExportSelectedData={true} />
                    <Column dataField="username" />
                    <Column dataField="fullName" caption="Nombres" />
                    <Column dataField="email" allowFiltering={false} />
                    <Column dataField="phoneNumber" caption="Telefono" allowFiltering={false} cellRender={e => formatNumberPhone(e.value)} />
                    <Column dataField="rolId" width={260} caption="Permisos">
                        <Lookup disabled={true} dataSource={createStore({name :'rol'})} valueExpr="id" displayExpr="name" />
                    </Column>
                    <Column dataField="active" caption="Activo" dataType="boolean"  width={100}/>
                    <Column dataField="initSession" dataType='datetime' caption='Inicio sessión' visible={false}/>
                    <Column dataField="endSession" dataType='datetime' caption='Fin de sessión' visible={false}/>
                    <Column dataField="password2" visible={false}/>
                    <Column dataField="pvt1" dataType="boolean"  visible={false}/>
                    <Column dataField="pvt2" dataType="boolean"  visible={false}/>
                    <Column dataField="pvt3" dataType="boolean"  visible={false}/>
                    <Column dataField="pvt4" dataType="boolean"  visible={false}/>
                    <Column dataField="useSessionTime" dataType="boolean"  visible={false}/>
                    <Editing
                        mode="popup"
                        allowUpdating={true}
                        useIcons={true}
                    >
                        <Popup title="Administrar" showTitle={true} width={430} height={630}>
                        </Popup>
                        <Form colCount={2}>
                            <Item dataField="username" colSpan={2}>
                                <RequiredRule message="El nombre de usuario es requerido" />
                                <StringLengthRule max={50} min={5} message="Máximo de caracteres 100 y 2 mínimo" />
                            </Item>
                            <Item dataField="fullName"  colSpan={2}>
                                <RequiredRule message="El nombre es requerido" />
                                <StringLengthRule max={150} min={5} message="Máximo de caracteres 150 y 5 mínimo" />
                            </Item>
                            <Item dataField="email"  colSpan={2}>
                                <RequiredRule message="El email es requerido" />
                                <EmailRule />
                                <StringLengthRule max={50} min={5} message="Máximo de caracteres 50 y 5 mínimo" />
                            </Item>
                            <Item dataField="phoneNumber"  colSpan={2} editorType="dxNumberBox" >
                                <StringLengthRule max={20} min={0} message="Máximo de caracteres 20 y 0 mínimo" />
                            </Item>
                            <Item dataField="rolId"  colSpan={2}>
                                <RequiredRule message="El rol es requerido" />
                            </Item>
                            <Item dataField="initSession"  colSpan={2} editorOptions={{...editorOptsDateBox}}>
                            </Item>
                            <Item dataField="endSession"  colSpan={2} editorOptions={{...editorOptsDateBox}}>
                            </Item>
                            <Item dataField="useSessionTime" caption="Cerra sesion" colSpan={2} editorType="dxSwitch" editorOptions={{...editorOptionsSwitch}}></Item>
                            <Item dataField="pvt1"  colSpan={1} editorType="dxSwitch" editorOptions={{...editorOptionsSwitch}}>
                               
                            </Item>
                            <Item dataField="pvt2"  colSpan={1} editorType="dxSwitch" editorOptions={{...editorOptionsSwitch}}>
                               
                            </Item>
                            <Item dataField="pvt3"  colSpan={1} editorType="dxSwitch" editorOptions={{...editorOptionsSwitch}}>
                               
                            </Item>
                            <Item dataField="pvt4"  colSpan={1} editorType="dxSwitch" editorOptions={{...editorOptionsSwitch}}>
                               
                            </Item>

                        </Form>
                    </Editing>
                </DataGrid>
            </div>
        )
    }

}


export default Users;
